import React, { useState, useRef, useEffect, useContext } from 'react';
import { useSnackbar } from '../../../context/SnackBarContext';
import {
  Typography,
  TextField,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Input,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Select,
  List,
  ListItem,
  ListItemText,
  MenuItem,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import FormServicio from '../servicio/ServicioDet.component';
import { UserContext } from './../../../context/UserContext';
import { styled } from '@mui/material/styles';
import { findBarras } from '../../../services/productosDet.service';
import Quagga from 'quagga';

const AccordionDetailsCustom = styled(AccordionDetails)`
  display: flex;
  justify-content: center;
`;

export default function RegistrarProducto({ datosOtg, setDatosOtg }) {
  const { showSnackbar } = useSnackbar();
  const handleClickSnackbar = (message, severity) => {
    showSnackbar({ message, severity });
  };
    const [productosVariantes, setProductosVariantes] = useState([]);

const [selectedRows, setSelectedRows] = useState([]);
useEffect(() => {
  const allIds = productosVariantes.map((p) => p.id);
}, [productosVariantes]);

  const [serviciosAsignados, setServiciosAsignados] = useState({});
  const [mostrarEspere, setMostrarEspere] = useState(false);
  const [dropp, setDropp] = useState(false);
  const [variacionSeleccionada, setVariacionSeleccionada] = useState(null);

  const [codigosMultiples, setCodigosMultiples] = useState('');
  const scannerRef = useRef(null);
  const [isScanning, setIsScanning] = useState(false);

  const datosSession = useContext(UserContext);

  // Función para asignar servicio
  const handleAsignarServicio = (idVariacion, servicioSeleccionado) => {
    setServiciosAsignados((prev) => ({
      ...prev,
      [idVariacion]: servicioSeleccionado,
    }));

    if (datosOtg?.id_variacion === idVariacion) {
      setDatosOtg((prev) => ({
        ...prev,
        servicio: servicioSeleccionado,
      }));
    }
  };

  // Función para obtener variantes por código de barras individual
  const getVariantesPorCodigoBarras = (cod_barras) => {
    if (!cod_barras || cod_barras.trim() === '') return;

    setMostrarEspere(true);
    console.log('Buscando código de barras:', cod_barras);
    findBarras(cod_barras)
      .then((response) => {
        console.log('Response de API:', response);
        const nuevasVariantes = [];

        response.forEach((variante) => {
          const productoVariante = {
            id: variante.id_variacion,
            nombre_producto: variante.nombre_producto,
            talla: variante.Talla.nombre_talla,
            color: variante.Color.nombre_color,
            cod_barras: variante.cod_barras,
          };

          const yaExiste = productosVariantes.some((p) => p.id === productoVariante.id);
          if (!yaExiste) {
            nuevasVariantes.push(productoVariante);
          }
        });

        setProductosVariantes((prev) => [...prev, ...nuevasVariantes]);
        setMostrarEspere(false);
      })
      .catch(() => {
        setMostrarEspere(false);
        handleClickSnackbar('Producto no encontrado por código de barras.', 'error');
      });
  };

  // Función para buscar múltiples códigos
  const buscarMultiplesCodigos = async (codigos) => {
    setMostrarEspere(true);

    for (const codigo of codigos) {
      try {
        const response = await findBarras(codigo);

        const nuevasVariantes = [];

        response.forEach((variante) => {
          const productoVariante = {
            id: variante.id_variacion,
            nombre_producto: variante.nombre_producto,
            talla: variante.Talla.nombre_talla,
            color: variante.Color.nombre_color,
            cod_barras: variante.cod_barras,
          };

          const yaExiste = productosVariantes.some((p) => p.id === productoVariante.id);
          if (!yaExiste) {
            nuevasVariantes.push(productoVariante);
          }
        });

        setProductosVariantes((prev) => [...prev, ...nuevasVariantes]);
      } catch (error) {
        console.error(`Error buscando el código ${codigo}:`, error);
        handleClickSnackbar(`Código no encontrado: ${codigo}`, 'warning');
      }
    }

    setMostrarEspere(false);
  };

  // Manejar botón buscar múltiples códigos
  const manejarBuscarMultiples = () => {
    const listaCodigos = codigosMultiples
      .split(/\r?\n|,/)
      .map((c) => c.trim())
      .filter((c) => c.length > 0);

    if (listaCodigos.length === 0) {
      handleClickSnackbar('Ingrese uno o más códigos de barras.', 'warning');
      return;
    }

    buscarMultiplesCodigos(listaCodigos);
  };

  // Controlar selección de variante
  const handleSeleccionarVariacion = (variacion) => {
    setVariacionSeleccionada(variacion);
    setDropp(true);

    setDatosOtg((prev) => ({
      ...prev,
      id_variacion: variacion.id,
      id_colaborador: datosSession.id_colaborador,
    }));
  };

  const handleRowSelection = (params) => {
    const selectedRow = params.row;
    handleSeleccionarVariacion(selectedRow);
  };

  // Toggle escaneo con Quagga
  const toggleScanner = () => {
    if (isScanning) {
      Quagga.stop();
    } else {
      if (scannerRef.current) {
        Quagga.init(
          {
            inputStream: {
              type: 'LiveStream',
              constraints: {
                width: 640,
                height: 480,
                facingMode: 'environment',
              },
              target: scannerRef.current,
            },
            decoder: {
              readers: ['code_128_reader', 'ean_reader', 'ean_13_reader', 'upc_reader'],
            },
          },
          (err) => {
            if (err) {
              console.log('Error en la inicialización de Quagga:', err);
              return;
            }
            Quagga.start();
          }
        );

        Quagga.onDetected((data) => {
          const cod_barras = data.codeResult.code;
          console.log('Código detectado:', cod_barras);
          getVariantesPorCodigoBarras(cod_barras);
        });
      } else {
        console.log('ScannerRef no está disponible');
      }
    }

    setIsScanning(!isScanning);
  };

  useEffect(() => {
    if (scannerRef.current && isScanning) {
      Quagga.init(
        {
          inputStream: {
            type: 'LiveStream',
            constraints: {
              width: 640,
              height: 480,
              facingMode: 'environment',
            },
            target: scannerRef.current,
          },
          decoder: {
            readers: ['code_128_reader', 'ean_reader', 'ean_13_reader', 'upc_reader'],
          },
        },
        (err) => {
          if (err) {
            console.log('Error en la inicialización de Quagga:', err);
            return;
          }
          Quagga.start();
        }
      );

      Quagga.onDetected((data) => {
        const cod_barras = data.codeResult.code;
        console.log('Código detectado:', cod_barras);
        getVariantesPorCodigoBarras(cod_barras);
      });
    }

    return () => {
      if (isScanning) {
        Quagga.stop();
      }
    };
  }, [isScanning]);

  const columns = [
  { field: 'nombre_producto', headerName: 'Producto', width: 300 },
  
  { field: 'cod_barras', headerName: 'Barras', width: 180 },

{
  field: 'info',
  headerName: 'Información',
  flex: 1,
  width: 800,
  renderCell: (params) => {
    const idVariacion = params.row.id;

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: 1 }}>
        <FormServicio
          dropAcordion={true}
          getServiciosFromComponent={(servicios) => {
            // Actualizar la lista de productos variantes
            const updatedRows = productosVariantes.map((item) =>
              item.id === idVariacion ? { ...item, servicio: servicios } : item
            );
            setProductosVariantes(updatedRows);

            // Si es la variación seleccionada globalmente, actualiza datosOtg también
            if (datosOtg?.id_variacion === idVariacion) {
              setDatosOtg({ ...datosOtg, servicios });
            }
          }}
        />
      </Box>
    );
  },
},

];

  return (
  <>
    {/* Campo para múltiples códigos */}
    <TextField
      label="Pegar uno o varios códigos de barras"
      multiline
      rows={4}
      fullWidth
      value={codigosMultiples}
      onChange={(e) => setCodigosMultiples(e.target.value)}
      variant="outlined"
      margin="normal"
    />

    <Button
      variant="contained"
      color="primary"
      onClick={manejarBuscarMultiples}
      sx={{ mb: 2 }}
    >
      Buscar productos
    </Button>

    {/* Campo individual para buscar código de barras */}
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={12} md={6}>
        
        <Button
          variant="contained"
          color="primary"
          onClick={() => window.open('http://10.1.2.49/transferencias/', '_blank')}
          sx={{ mt: 1 }}
        >
          Consultar Transferencia RMS
        </Button>
        <Typography variant="body2" sx={{ mt: 1 }}>
  Luego de realizar la búsqueda de los productos, seguir los siguientes pasos:
</Typography>
<List dense sx={{ pl: 2 }}>
  <ListItem>
    <ListItemText primary="1. Hacer click en el nombre del producto." />
  </ListItem>
  <ListItem>
    <ListItemText primary="2. Seleccionar la falla del producto." />
  </ListItem>
  <ListItem>
    <ListItemText primary="3. Hacer click en el botón 'Agregar OTG'." />
  </ListItem>
  <ListItem>
    <ListItemText primary="4. Repetir el proceso para cada producto que se necesite registrar." />
  </ListItem>
  <ListItem>
    <ListItemText primary="5. Click en 'Guardar Todo' para generar las OTG's." />
  </ListItem>
</List>
      </Grid>
    </Grid>

    {/* Escáner */}
    {isScanning && (
      <Box sx={{ width: '100%', height: 400, border: '1px solid gray' }}>
        <div ref={scannerRef} style={{ width: '100%', height: '100%' }}></div>
      </Box>
    )}

    {/* Grid principal con DataGrid y sección de información */}
    <Grid container spacing={2} sx={{ mt: 2 }}>
      {/* Columna con DataGrid */}
      <Grid Grid item xs={12} md={12}>
    <Box sx={{ height: 600, width: '100%' }}>
      <DataGrid
        columns={columns}
        rows={productosVariantes}
        getRowId={(row) => row.id}
        getRowHeight={() => 100}
        selectionModel={selectedRows}
        onSelectionModelChange={(newSelection) => {
          setSelectedRows(newSelection);
        }}
        onRowClick={handleRowSelection}
      />

        </Box>
      </Grid>

      {/* Columna con información de tienda e información del servicio */}
      <Grid item xs={12} md={12}>
        {/* Información de la tienda */}
        <Accordion expanded={dropp} onChange={() => setDropp(!dropp)}>
  <AccordionSummary expandIcon={<ExpandMore />}>
    <Typography variant='subtitle1'>Información de la tienda</Typography>
  </AccordionSummary>
  <AccordionDetailsCustom>
                  <Grid item md={10}>
                    <Grid container justifyContent='space-around' alignItems={'center'}>
                      <Typography>Usuario: {datosSession.usuario}</Typography>
        
                      <TextField
                        label='Responsable'
                        name='responsable'
                        value={datosOtg.responsable}
                        onChange={(e) => {
                          setDatosOtg({ ...datosOtg, responsable: e.target.value });
                        }}
                      />
                    </Grid>
                  </Grid>
                 </AccordionDetailsCustom>
</Accordion>

        {/* Información del servicio (FormServicio) */}
        
      </Grid>
    </Grid>
  </>
);

}

